var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"btn-back",attrs:{"role":"navigation","type":"button"},on:{"click":_vm.navigate}},[_c('div',{staticClass:"btn-back__icon"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.arrow)}})]),_c('div',{staticClass:"btn-back__text"},[(_vm.text)?_c('span',[_vm._v(_vm._s(_vm.text))]):_c('span',[_vm._v("Torna indietro")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }